import { useBienContext } from '../BienContext'
import PropertyUnits from '../property_units'
import Vente from '../vente'
import Location from '../location'
import Fiscalite from '../fiscalite'
import Assurances from '../assurances'
import Copropriete from '../copropriete'
import Monopropriete from '../monopropriete'
import Visites from '../visites'
import { getHasMandatOfTypeFunc } from '../biensSlice'
import MacroProcessButtons from '../macro-processes/Buttons'
import ProcessContainerModal from '@/features/macro-process-creation/components/ProcessContainerModal'
import MacroProcessEditModal from '@/features/macro-process-edit/components/MacroProcessEditModal'

export default () => {
  const { bien } = useBienContext() 

  const hasMandatOfType = getHasMandatOfTypeFunc(bien)

  return(
    <div>
      <div className="p-4">
        <MacroProcessButtons bienId={bien.id} />
        <ProcessContainerModal bienId={bien.id} />
        <MacroProcessEditModal />
        { (bien.type_bien === 'immeuble' && bien.unites_count > 0) && 
            <div id="property_units"><PropertyUnits.Detail /></div>
        }
        { hasMandatOfType('vente') && <div id='vente'><Vente.Detail /></div> }
        { (bien.type_bien !== 'immeuble' && (hasMandatOfType('location') || !!bien.current_location)) && <div id='location'><Location.Detail /></div> }
        <div id='fiscalite'><Fiscalite.Detail /></div>
        { (bien.type_bien === 'appartement' || bien.type_bien === 'autre') && !bien.immeuble_id &&
          <div id='copropriete'><Copropriete.Detail /></div>
        }
        { bien.type_bien === 'immeuble' && bien.unites_count != 0 &&
            <div id='monopropriete'><Monopropriete.Detail /></div>
        }
        <div id='assurances'><Assurances.Detail /></div>
        <div id='visites'><Visites.Detail /></div>
      </div>
    </div>
  )
}